export default {"src":"/_next/static/image/public/images/ic_recieved.49c08600cd657d3fbbc5be9ff68b6703.svg","height":53,"width":56};